export const LanguageMixin = {
  data () {
    return {
      // languages: ['EN', 'NL', 'DE', 'ES', 'FR'],
      languages: ['EN', 'NL']
    }
  }
}
